import React, { useState, useCallback } from 'react';
import { FiDownload } from 'react-icons/fi';
import { FaSpinner } from 'react-icons/fa';
import { downloadListingScoreExcel } from './downloadListingScoreExcel';
import styles from './ListingScoreDownloadButton.module.css';

// Top-right "Download" button, level with the page heading. Exports the current
// run to Excel via the backend (bulk → data + Summary; single → data only).
// Pass exactly one of { taskId } (bulk) or { asin } (single).
const ListingScoreDownloadButton = ({ token, taskId, asin, disabled = false, label = 'Download' }) => {
    const [downloading, setDownloading] = useState(false);

    const handleClick = useCallback(async () => {
        if (downloading) return;
        try {
            setDownloading(true);
            await downloadListingScoreExcel({ token, taskId, asin });
        } catch (err) {
            alert(err.message || 'Download failed. Please try again.');
        } finally {
            setDownloading(false);
        }
    }, [downloading, token, taskId, asin]);

    return (
        <button
            type="button"
            className={styles.downloadBtn}
            onClick={handleClick}
            disabled={disabled || downloading || (!taskId && !asin)}
            aria-label={label}
        >
            <span className={`${styles.icon} ${downloading ? styles.spin : ''}`}>
                {downloading ? <FaSpinner /> : <FiDownload />}
            </span>
            <span>{downloading ? 'Preparing…' : label}</span>
        </button>
    );
};

export default ListingScoreDownloadButton;
